import { FormControlLabel, styled } from '@mui/material';

export const ButtonControl = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  width: '100%',
  padding: 0,

  '.MuiRadio-root': {
    display: 'none',
  },

  '.MuiFormControlLabel-label': {
    width: '100%',
    textAlign: 'center',
    borderRadius: 3 * Number(theme.shape.borderRadius),
    fontWeight: 500,

    ...(isSelected
      ? {
          padding: '13px 21px',
          border: '3px solid',
        }
      : {
          padding: theme.spacing(2, 3),
          boxShadow: theme.shadows[1],
        }),
  },
}));
